import React from "react";
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";
import ApplyNowButton from "../Buttons/ApplyNowButton";
import HomeGroupImage from "../../img/HomeGroupImage.png";
import GroupImageDesktop from "../../img/GroupImageDesktop.png";
import dotted from "../../img/dottedHero.png";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  box: {
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: { xs: "column", md: "row" },
    background:
      "linear-gradient(185deg, rgba(255,255,255,1) 0%, rgba(246,246,246,1) 100%)",
    borderBottomRightRadius: "9rem",
    maxWidth: { md: "100vw" },
  },
  title: {
    color: theme.palette.red.main,
    fontWeight: "600",
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontSize: { xs: "14px", md: "16px" },
    textAlign: "center",
    mt: { xs: "10px", md: 0 },
  },
  subtitle: {
    maxWidth: { xs: "283px", md: "540px", lg: "638px" },
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "48px", md: "40px", lg: "50px", xl: "60px" },
    lineHeight: { xs: "60px", md: "55px", lg: "60px", xl: "65px" },
    textAlign: { xs: "center", md: "start" },
    mt: "29px",
    mb: "68px",
  },
  span: { fontWeight: "bold" },
  img: {
    mobile: {
      width: "100%",
    },
    desktop: {
      height: "40rem",
    },
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  lineBox: {
    display: "flex",
    height: "21px",
    justifyContent: { xs: "center", md: "flex-start" },
    alignItems: "center",
  },
  child: {
    display: "flex",
    justifyContent: { xs: "center", md: "flex-start" },
    alignItems: { xs: "center", md: "flex-start" },
    flexDirection: "column",
    ml: { md: "30px", lg: "70px", xl: "100px" },
  },
  container: {
    padding: "3rem",
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "center", md: "flex-start" },
    width: "100vw",
    justifyContent: "center",
  },
});

const Funding = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const { title, subtitle } = useTranslation(pathname, "Funding");

  return (
    <Box sx={classes.box}>
      {isMobile ? null : (
        <img src={GroupImageDesktop} alt="group" style={classes.img.desktop} />
      )}
      <Box
        sx={{
          ...classes.container,
        }}
      >
        <Box sx={classes.child}>
          <Box sx={classes.lineBox}>
            {isMobile ? null : <div style={classes.line}></div>}
            <Typography sx={classes.title}>{title}</Typography>
          </Box>

          <Typography sx={classes.subtitle}>
            {subtitle[0]}
            <span style={classes.span}>{subtitle[1]}</span>
          </Typography>
          <ApplyNowButton />
        </Box>
      </Box>
      {isMobile ? (
        <img src={HomeGroupImage} alt="group" style={classes.img.mobile} />
      ) : null}

      {!isMobile ? (
        <div>
          <div
            style={{
              backgroundImage: `url(${dotted})`,
              transform: "translate(-4.25rem, 1rem)",
              color: "#e6e6e6",
              fontSize: "0.8rem",
              fontFamily: theme.typography.anaHeim.regular,
              position: "relative",
              zIndex: 2,
            }}
          ></div>
          <div
            style={{
              position: "relative",
              top: "0",
              right: "0",
              width: "6rem",
              height: "25rem",
              background: "rgba(238,254,252,1)",
              borderBottomLeftRadius: "9rem",
            }}
          ></div>
        </div>
      ) : null}
    </Box>
  );
};

export default Funding;
